(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */
  angular
    .module('compartilhamentos', [
      'ui.router',
      'ui.bootstrap.modal',
      'restangular',
      'alert-message',
      'uoModule',
      'uoArvoreNivelModule',
      'ConstantVfiltroModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'angularMoment',
      'modalInfoConfirmModule'
    ])
    .constant('EntidadeMap', {
      'Veículos': 'vehicles',
      'Usuários': 'users',
      'Pontos de Referência': 'landmarks',
      'Motoristas': 'drivers',
      'Grupos de Veículo':'vehicleGroups',
      'Serviços':'services',
      'Departamentos de motorista': 'driverDepartments',
      'Passageiros': 'passengers',
      'Cercas Eletrônicas': 'geofences',
      'TODAS AS ENTIDADES': 'allEntities'
    })
    .constant('VehiclesMap', {
      'Veículos': 'vehicles',
      'Usuários': 'users',
      'Pontos de Referência': 'landmarks',
      'Motoristas': 'drivers',
      'Grupos de Veículo':'vehicleGroups',
      'Serviços':'services',
      'Departamentos de motorista': 'driverDepartments',
      'Passageiros': 'passengers',
      'Cercas Eletrônicas': 'geofences'
    });
}());
